import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import logo3 from 'assets/images/CSA.svg'
import logo2 from 'assets/images/ISO27001.svg'
import logo1 from 'assets/images/SOC.svg'
import logo4 from 'assets/images/SSL.svg'

const SecureLogos = () => (
  <Box flexDirection="row" gap="s16">
    <img src={logo1} alt="SOC" title="SOC" />
    <img src={logo2} alt="ISO27001" title="ISO27001" />
    <img src={logo3} alt="CSA" title="CSA" />
    <img src={logo4} alt="SSL" title="SSL" />
  </Box>
)

export default SecureLogos
